import React from "react";

import { Helmet } from "react-helmet";

import "./login.css";

const Login = (props) => {
  return (
    <div className="login-container">
      <Helmet>
        <title>BIOLAB</title>
        <meta property="og:title" content="BIOLAB Platform" />
        <link rel="canonical" href="https://dev.portal.biolab.com.es/" />
      </Helmet>
      <div className="login-thq-content-elm">
        <img
          alt="BIOLAB Logo"
          src="/biolab-logo-200h.png"
          className="login-thq-biolablogo-elm"
        />
        <div className="login-thq-login-elm">
          <div className="login-thq-title-elm">
            <h1 className="login-thq-text-elm1 headline01">Iniciar sesión</h1>
            <h2 className="login-thq-text-elm2 bodystandard">
              Accede con tu cuenta de Google o Microsoft
            </h2>
          </div>
          <div className="login-thq-buttons-sso-elm">
            <button
              type="button"
              className="login-thq-google-elm bodystandard button"
              onClick={() => {
                window.location.href = "/auth/google";
              }}
            >
              <img
                alt="Google Logo"
                src="/logo-google.svg"
                className="login-thq-google-logo-elm1"
              />
              <span className="login-text1">Google</span>
            </button>
            <button
              type="button"
              className="login-thq-microsoft-elm button bodystandard"
              onClick={() => {
                window.location.href = "/auth/microsoft";
              }}
            >
              <img
                alt="Microsoft Logo"
                src="/logo-microsoft.svg"
                className="login-thq-google-logo-elm2"
              />
              <span className="login-text2">Microsoft</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
